module.exports = __webpack_public_path__ + "media/images/desktop-disney-world-67f696942c25df868ff2a3562df5813e.jpg";